import styled from 'styled-components';

import { rowHeight } from './constants';
import { TimelineEdgeArrowDirection } from './get-timeline-edge-arrow';

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
`;

export const ArrowButton = styled.button<{
  $top: number;
  $side: TimelineEdgeArrowDirection;
}>`
  position: absolute;
  top: ${({ $top }) => `${$top}px`};
  left: ${({ $side, theme }) =>
    $side === TimelineEdgeArrowDirection.Left ? theme.spacing(1) : 'auto'};
  right: ${({ $side, theme }) =>
    $side === TimelineEdgeArrowDirection.Right ? theme.spacing(1) : 'auto'};

  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rowHeight}px;
  padding: 0;

  background: none;
  border: none;
  cursor: pointer;
  pointer-events: auto;
`;

export const ArrowChip = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;

  color: ${({ theme }) => theme.palette.grey[700]};
  font-size: 1.2rem;

  background: ${({ theme }) => theme.palette.grey[300]};
  border-radius: 6px;
`;
